import React, { useEffect } from 'react'
import Swiper from 'swiper'

import { Item } from './item'
import { rhythm } from '../../utils/typography'

import './index.scss'

export const Category = ({ categories, category, selectCategory }) => {
  useEffect(() => {
    var mySwiper = new Swiper('.category-container', {
      wrapperClass: 'category-wrapper',
      slideClass: 'category-wrapper .item',
      slidesPerView: 'auto',
    })
  }, [])

  return (
    <div
      className="category-container"
      role="tablist"
      id="category"
      style={{
        margin: `0 -${rhythm(3 / 4)}`,
      }}
    >
      <div className="category-wrapper">
        <Item
          title={'All'}
          category={category}
          selectCategory={selectCategory}
        />
        {categories.map((item, idx) => (
          <Item
            key={idx}
            title={item}
            category={category}
            selectCategory={selectCategory}
          />
        ))}
      </div>
    </div>
  )
}
